import { Box, Button, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import { MainContainer } from '../styles';
import { ModalActions } from '../components/Modal';
import { useContext, useEffect, useState } from 'react';
import ProductCustomizeCard from '../components/ProductCard/ProductCustomizeCard';
import { getProducts } from '../api/products';
import { ProductsListContext } from '../contexts/ProductsListContext';
import { PAGES_SLUGS } from '../variables';
import CustomizeResume from './CustomizeResume';

const customize = () => {
  const { t } = useTranslation();

  const [selectedIndex, setSelectedIndex] = useState(null);// usado para adicionar a border
  const [history, setHistory] = useState([]);
  const [step, setStep] = useState(1);
  console.log('History: ', history);
  console.log('Step: ', step);


  const handleNext = (selectedValue) => {
    setHistory(prev => [...prev, selectedValue]);
    if (step === 4 && selectedIndex === 1) {
      setStep(prev => prev + 2);
    } else {
      setStep(prev => prev + 1);
    }
    setSelectedIndex(null);
  };
  const handleBack = () => {
    setHistory(prev => prev.slice(0, -1)); // pop último
    if (step === 6 && history[3].title.toLowerCase().includes('curta')) {
      setStep(prev => prev - 2);
    } else {
      setStep(prev => prev - 1);
    }
  };
  const {
    products, setProducts, navigate, setIsLoading
  } = useContext(ProductsListContext);
  if (!products) throw new Error('ProductsListContext deve ser usado dentro de ProductsListProvider');

  useEffect(() => {
    if (step === null || step === 10) return;

    setIsLoading(true);

    getProducts({
      searchParams: {
        season: 'Configurador',
        collection: t(`customize.steps.${step}`).toUpperCase()
      }
    })
      .then(({ displayedProducts, productsTotal }) => {
        if (step === 9 && history.length > 4) {
          if (history[3].title.toLowerCase().includes('curta')) {
           displayedProducts = displayedProducts.filter((element) => !element.title.toLowerCase().includes('punho'));
          }
        }
        setProducts({
          list: displayedProducts,
          total: productsTotal
        });
        setIsLoading(false);
      })
      .catch(({ response: { status } }) => {
        if (status === 401) navigate('/login');
        if (status === 400 || status > 401)
          navigate(PAGES_SLUGS.notFound, { replace: true });
        setIsLoading(false);
      });

  }, [step]);
  return (
    <MainContainer>
      <Container>
        <Grid container>
          <Grid xs={12}>
            <Box
              sx={{
                textAlign: 'center'
              }}
            >
              <Typography variant="h3">{t('customize.title')}</Typography>
              <Typography variant="h3" marginTop={2}>
                {step !== 10
                  ? `${t('customize.subtitle')} ${t(`customize.steps.${step}`)}`
                  : t(`customize.steps.${step}`)
                }
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                width: '100%',
                'justify-content': 'center',
                'margin': '16px 0 36px 0',
                gap: 2
              }}
            >
              <ModalActions>
                <Button
                  variant="contained"
                  title={t('customize.back')}
                  disabled={step === 1}
                  onClick={() => handleBack()}
                  sx={{
                    width: '100%',
                    maxWidth: '100px'
                  }}>
                  {t('customize.back')}
                </Button>
              </ModalActions>
              <Typography marginTop={2}>{step} de 10</Typography>
              <ModalActions>
                <Button
                  variant="contained"
                  title={t('customize.next')}
                  disabled={step === 10 | selectedIndex === null}
                  onClick={() => handleNext(products.list[selectedIndex])}
                  sx={{
                    width: '100%',
                    maxWidth: '100px'
                  }}>
                  {t('customize.next')}
                </Button>
              </ModalActions>
            </Box>
          </Grid>
        </Grid>
        {step !== 10 ? (
          <Grid spacing={5} sx={{
            display: 'grid',
            'grid-template-columns': {
              xs: 'repeat(2, 1fr)', // mobile (ex: 2 colunas)
              sm: 'repeat(3, 1fr)', // small tablets
              md: 'repeat(4, 1fr)', // tablets landscape / small desktops
              lg: 'repeat(5, 1fr)' // desktops grandes
            },
            'gap': '20px'
          }}>
            {products.list.map((product, index) => (
              <Grid
                key={`product-card-${product.reference}-${index}`}
                xs={12}
                md={3}
                onClick={() => setSelectedIndex(index)}
                sx={{
                  border: selectedIndex === index ? '1px solid black' : '1px solid #DDD',
                  borderRadius: 1,
                  cursor: 'pointer',
                  transition: 'border 0.2s'
                }}

              >
                <ProductCustomizeCard
                  product={product}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <CustomizeResume products={history} />
        )}
      </Container>
    </MainContainer>
  )
    ;
};

export default customize;
